<template>
    <AdminLayout>
        <section class="flex items-start pl-6 pr-14 space-x-9">
            <div class="w-60 shrink-0 sticky top-20 mt-12 bg-white shadow-[-1px_1px_4px_1px_rgba(0,0,0,0.05)] rounded-md overflow-hidden">
                <ul>
                    <li v-if="role && (role.name === 'Super Admin' || role.permissions.includes('attendance_settings'))" class="flex items-center space-x-2.5 text-sm font-medium flex-nowrap p-4 hover:text-[#3B82F6] transition-all cursor-pointer" :class="tab == 'settings' ? 'bg-[#ECF6FF] text-[#3B82F6]' : 'bg-white text-[#767676]'" @click="tab = 'settings'">
                        <span>Attendance Settings</span>
                    </li>
                    <li v-if="role && (role.name === 'Super Admin' || role.permissions.includes('attendance_adjustment'))" class="flex items-center space-x-2.5 text-sm font-medium flex-nowrap p-4 hover:text-[#3B82F6] transition-all cursor-pointer" :class="tab == 'adjustment' ? 'bg-[#ECF6FF] text-[#3B82F6]' : 'bg-white text-[#767676]'" @click="tab = 'adjustment'">
                        <span>Attendance Adjustment</span>
                    </li>
                    <li v-if="role && (role.name === 'Super Admin' || role.permissions.includes('attendance_report'))" class="flex items-center space-x-2.5 text-sm font-medium flex-nowrap p-4 hover:text-[#3B82F6] transition-all cursor-pointer" :class="tab == 'report' ? 'bg-[#ECF6FF] text-[#3B82F6]' : 'bg-white text-[#767676]'" @click="tab = 'report'">
                        <span>Attendance Report</span>
                    </li>
                    <li v-if="role && (role.name === 'Super Admin' || role.permissions.includes('wfh_report'))" class="flex items-center space-x-2.5 text-sm font-medium flex-nowrap p-4 hover:text-[#3B82F6] transition-all cursor-pointer" :class="tab == 'wfh' ? 'bg-[#ECF6FF] text-[#3B82F6]' : 'bg-white text-[#767676]'" @click="tab = 'wfh'">
                        <span>WFH Report</span>
                    </li>
                    <li v-if="role && (role.name === 'Super Admin' || role.permissions.includes('date_change_report'))" class="flex items-center space-x-2.5 text-sm font-medium flex-nowrap p-4 hover:text-[#3B82F6] transition-all cursor-pointer" :class="tab == 'date' ? 'bg-[#ECF6FF] text-[#3B82F6]' : 'bg-white text-[#767676]'" @click="tab = 'date'">
                        <span>Date Change</span>
                    </li>
                </ul>
            </div>
            <div class="grow overflow-hidden py-2">

                <div v-if="role && (role.name === 'Super Admin' || role.permissions.includes('attendance_settings')) && tab == 'settings'">
                    <AttendanceSetting />
                </div>
                <div v-if="role && (role.name === 'Super Admin' || role.permissions.includes('attendance_adjustment')) && tab == 'adjustment'">
                    <AttendanceAdjustment />
                </div>
                <div v-if="role && (role.name === 'Super Admin' || role.permissions.includes('attendance_report')) && tab == 'report'">
                    <AttendanceReport />
                </div>
                <div v-if="role && (role.name === 'Super Admin' || role.permissions.includes('wfh_report')) && tab == 'wfh'">
                    <WFHReport />
                </div>
                <div v-if="role && (role.name === 'Super Admin' || role.permissions.includes('date_change_report')) && tab == 'date'">

                    <DateChange />
                </div>
            </div>
        </section>
    </AdminLayout>
</template>

<script>
import AdminLayout from "@/Pages/AdminDashboard/AdminLayout.vue";
import AttendanceSetting from "@/Pages/Settings/AttendanceSetting.vue";
import AttendanceAdjustment from "@/Pages/Settings/AttendanceAdjustment.vue";
import AttendanceReport from "@/Pages/Settings/AttendanceReport.vue";
import WFHReport from "@/Pages/Settings/WFHReport.vue";
import DateChange from "@/Pages/Settings/DateChange.vue";

export default {
    name: 'AttendanceManagement',
    data() {
        return {
            tab: 'settings',
            role: null
        }
    },
    components: {
        AdminLayout,
        AttendanceSetting,
        AttendanceAdjustment,
        AttendanceReport,
        WFHReport,
        DateChange,
    },
    mounted() {
        const storedRole = localStorage.getItem("role");
        // console.log("Stored role:", storedRole);
        try {
            this.role = storedRole;
        // console.log("Parsed role:", this.role);
        //console.log("Permissions:", this.role.permissions);
            if (this.role.name === 'Super Admin') {
                this.tab = 'settings'; // Default for Super Admin
            } else if (this.role.permissions.includes('attendance_settings')) {
                this.tab = 'settings';
            } else if (this.role.permissions.includes('attendance_adjustment')) {
                this.tab = 'adjustment';
            } else if (this.role.permissions.includes('attendance_report')) {
                this.tab = 'report';
            } else if (this.role.permissions.includes('wfh_report')) {
                this.tab = 'wfh';
            } else if (this.role.permissions.includes('date_change_report')) {
                this.tab = 'date';
            }
        } catch (error) {
            console.error("Invalid role JSON", error);
        }
    },
    methods: {
    }
}
</script>